export const PAGE_SIZE = 500;
export const SESSION_EXPIRED_ERROR_CODE = 2501;
